import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  StylableButtonDefinition,
  StylableButtonPlatformProps,
  StylableButtonCarmiProps,
} from '../StylableButton.types';

export const props = withCompInfo<
  StylableButtonPlatformProps,
  StylableButtonDefinition,
  StylableButtonCarmiProps
>()([], (_, carmiData) => {
  return { ...carmiData, link: carmiData.link && { ...carmiData.link } };
});

export default createComponentMapperModel({
  props,
});
